import * as Sentry from '@sentry/browser';
import ng from 'angular';

import { StaffConst } from '@/configuration';
import {
    AlertManagerService,
    AuthContextService,
    SentryErrorEmitterService,
    ValidateMinLength,
    ValidateNotEmpty
} from '@/services';

import './support-modal.scss';

export type SupportFormData = {
    accountId: string,
    accountName: string,
    data: any,
    location: string,
    mail: string,
    name: string,
}

export class OrganViewPanelSupportModalController implements ng.IController {
    public static $inject: string[] = [
        '$http',
        '$translate',
        'alertManager'
    ];

    public companyName = 'hosting.de';
    public displayPanel: { promise: boolean; contact: boolean };
    public formSubmitDisabled = false;
    public contactFormData: any;
    public isIndividualProductRequest = false;
    public productGroup = '';
    public contactFormTypes: { name: string; value: string }[];
    public contactFormCategories: any;
    public commentValidationInstructions: any[] = [];
    public skipAuthCheck: boolean;
    public supportFormDataOverwrite: SupportFormData;

    protected staff: string = StaffConst.kahrs.name;

    private lastSelectedFormType = 'support';

    constructor(
        private $http: ng.IHttpService,
        private $translate: ng.translate.ITranslateService,
        private alertManager: AlertManagerService
    ) {}

    public $onInit() {
        if (this.skipAuthCheck) {
           this.companyName =  'hosting.fr';
        } else {
            this.companyName = [undefined, null].indexOf(AuthContextService.accountOrganizationInformation) === -1
            ? AuthContextService.accountOrganizationInformation.companyName
            : '';
        }

        this.commentValidationInstructions = [
            {
                instructions: null,
                validator: new ValidateMinLength(this.$translate, 5)
            }, {
                instructions: null,
                validator: new ValidateNotEmpty(this.$translate)
            }
        ];

        this.contactFormData = {
            category: this.isIndividualProductRequest ? 'Technical' : null,
            comment: '',
            name: '',
            type: this.isIndividualProductRequest ? 'support' : 'feedback'
        };

        this.contactFormTypes = [
            {
                name: this.$translate.instant('TR_100119-3c921f_TR'),
                value: 'support'
            }, {
                name: this.$translate.instant('2e19b85f-d60b-4d98-98c3-725395f8a5ec'),
                value: 'feedback'
            }
        ];

        this.contactFormCategories = {
            feedback: [
                {
                    name: this.$translate.instant('TR_110119-d5d874_TR'),
                    value: 'Produkte'
                }, {
                    name: this.$translate.instant('CONTACT.FEEDBACK.CATEGORY.OPTIONS.USABILITY'),
                    value: 'Usability'
                }, {
                    name: this.$translate.instant('CONTACT.FEEDBACK.CATEGORY.OPTIONS.API'),
                    value: 'API'
                }, {
                    name: this.$translate.instant('CONTACT.FEEDBACK.CATEGORY.OPTIONS.DOCUMENTATION'),
                    value: 'Dokumentation'
                }, {
                    name: this.$translate.instant('CONTACT.FEEDBACK.CATEGORY.OPTIONS.OTHERS'),
                    value: 'Sonstiges'
                }
            ],
            support: [
                {
                    name: this.$translate.instant('TR_110119-912054_TR'),
                    value: 'Technical'
                }, {
                    name: this.$translate.instant('TR_110119-fe163a_TR'),
                    value: 'Billing'
                }
            ]
        };
    }

    public sendContactRequest = () => {
        try {
            if (this.formSubmitDisabled) return;

            let formData: SupportFormData;

            if (this.skipAuthCheck) {
                formData = {
                    accountId: this.supportFormDataOverwrite.accountId || 'test',
                    accountName: this.supportFormDataOverwrite.accountName || 'test',
                    data: ng.copy(this.contactFormData),
                    location: window.location.hostname,
                    mail: this.supportFormDataOverwrite.mail || 'test',
                    name: this.supportFormDataOverwrite.name || 'test',

                }
            } else {
                const user = AuthContextService.user;
                const account = AuthContextService.account;
                formData = {
                    accountId: account.id,
                    accountName: account.name,
                    data: ng.copy(this.contactFormData),
                    location: window.location.hostname,
                    mail: user.emailAddress,
                    name: user.name,
                };
            }

            if (this.isIndividualProductRequest && this.productGroup.length > 0) {
                // Dieser Text muss nicht übersetzt werden, da er nur für unseren Support gedacht ist ;)
                formData.data.comment = `Kundenanfrage zu einer individuellen "${this.productGroup}"-Lösung:\n`
                    + formData.data.comment;
            }

            this.formSubmitDisabled = true;

            const promise = this.$http.post(
                '/utils/contact',
                formData,
                { headers: { 'Content-Type': 'application/json' } }
            );

            promise.then(
                (res) => {
                    this.alertManager.success(this.$translate.instant('TR_110119-ceaca6_TR'));
                    this.formSubmitDisabled = false;
                    this.contactFormData = {
                        category: 'Technical',
                        comment: '',
                        name: '',
                        type: 'support'
                    };

                    // Close the panel.
                    this.displayPanel.contact = false;
                },
                (reject) => {
                    this.alertManager.error(this.$translate.instant('TR_110119-eaea05_TR'));
                    SentryErrorEmitterService.sendSentryReport(
                        this.$translate.instant('TR_110119-15f3c9_TR'),
                        { requestData: formData, response: reject },
                        { key: 'feedback' },
                        Sentry.Severity.Error,
                        true
                    )
                    this.formSubmitDisabled = false;
                    // TODO add error message
                }
            );
        } catch(err) {
            console.error(err);
            throw err;
        }
    };

    public formTypeChanged = () => {
        if (this.lastSelectedFormType !== this.contactFormData.type) {
            this.contactFormData.category = this.contactFormCategories[this.contactFormData.type][0].value;
            this.lastSelectedFormType = this.contactFormData.type;
        }
    };
}

export class OrganViewPanelSupportModalComponent implements ng.IComponentOptions {
    public bindings = {
        displayPanel: '=',
        isIndividualProductRequest: '<?',
        productGroup: '<?',
        skipAuthCheck: '<?',
        supportFormDataOverwrite: '<?',
    };
    public controller = OrganViewPanelSupportModalController;
    public template = require('./support-modal.html');
}
